/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { Statement, statementSchema } from './statement';

export interface Data10 {
  statement: Statement[];
}

export const data10Schema: Schema<Data10> = object({
  statement: ['Statement', array(lazy(() => statementSchema))],
});
